// extracted by mini-css-extract-plugin
module.exports = {"container":"NewPasswordPopupContent_container__1XR_D","loader":"NewPasswordPopupContent_loader__-RVxH"};